"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGIN_EVENT = void 0;
const LOGIN_EVENT = exports.LOGIN_EVENT = 'login';